import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import {NgxImageCompressService} from 'ngx-image-compress';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AppRoutes } from './app.routing';

import { SidebarModule } from './layouts/admin/sidebar/sidebar.module';
import { NavbarModule } from './layouts/admin/navbar/navbar.module';
import { FooterModule } from './layouts/admin/footer/footer.module';
import { FixedpluginModule } from './layouts/admin/fixedplugin/fixedplugin.module';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common'
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { NotificationService } from './_services/notification.service';
import { LoginComponent } from './login/login.component';
import { AuthService } from './_services/auth.service';
import { UserService } from './_services/user.service';
import { VehiclePositionComponent } from './vehiclePosition/vehiclePosition.component';
import { VehicleRoutesComponent } from './vehicleRoutes/vehicleRoutes.component';
import { MapRoutesComponent } from './vehicleRoutes/mapRoutes/mapRoutes.component';
import { UserEditResolver } from './_resolvers/user-edit.resolver';
import { PositionRouteResolver } from './_resolvers/positions-route.resolver';
import { ForgotPassDialogComponent } from './login/forgot-pass-dialog/forgot-pass-dialog.component';
import { ForgotPassChangeComponent } from './forgot-pass-change/forgot-pass-change.component';
import { PassTokenResolver } from './_resolvers/pass-token.resolver';
import { ChartsModule } from 'ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LogListComponent } from './log-list/log-list.component';

import {  HighchartsChartModule } from 'highcharts-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ClientLayoutComponent } from './layouts/client/client-layout.component';
import { HeaderComponent } from './layouts/client/component/header/header.component';
import { SidebarComponent } from './layouts/client/component/sidebar/sidebar.component';
import { ToggleSidebarComponent } from './layouts/client/component/toggle-sidebar/toggle-sidebar.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmDialog/confirmDialog.component';
import { ErrorMessageDialogComponent } from 'src/app/shared/errorMessageDialog/errorMessageDialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ServiceManLayoutComponent } from './layouts/serviceMan/serviceMan-layout.component';
import { ProgressLoaderModule } from './shared/progressLoader/progressLoader.module';
import { ChangeDialogComponent } from './login/changeDialog/changeDialog.component';
import { AddClientFinanceComponent } from './pages/admin/add-client-finance/add-client-finance.component';
import { TollDistributerLayoutComponent } from './layouts/tollDistributerLayout/tollDistributerLayout.component';
import { NavbarServiceService } from './layouts/admin/navbar-service.service';
import { InvoiceSendOptionsComponent } from './pages/admin/display-finance-account/invoice-send-options/invoice-send-options.component';
import { TextInputConfirmationDialogComponent } from './shared/text-input-confirmation-dialog/text-input-confirmation-dialog.component';


export function tokenGetter() {
  return localStorage.getItem('admin-token') || localStorage.getItem('client-token') || localStorage.getItem('serviceMan-token');
}

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule

  ]

})
export class MaterialModule { }



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    LoginComponent,
    VehiclePositionComponent,
    VehicleRoutesComponent,
    MapRoutesComponent,
    ForgotPassDialogComponent,
    ForgotPassChangeComponent,
    LogListComponent,
    ClientLayoutComponent,
    ServiceManLayoutComponent,
    TollDistributerLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    ToggleSidebarComponent,
    ConfirmationDialogComponent,
    ErrorMessageDialogComponent,
    ChangeDialogComponent,
    AddClientFinanceComponent,
    InvoiceSendOptionsComponent,
    TextInputConfirmationDialogComponent
    
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,

    FormsModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule,
    RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),

    MaterialModule,
    ProgressLoaderModule,
    MatNativeDateModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    FixedpluginModule,
    ReactiveFormsModule,

    ChartsModule,
    NgxChartsModule,
    MatFormFieldModule,
    MatInputModule,
    HighchartsChartModule,
    NgApexchartsModule,

    DragDropModule,

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ['logimapsgpsapi.azurewebsites.net','localhost:5000'],
        blacklistedRoutes: ['logimapsgpsapi.azurewebsites.net/api/auth']
      }
    })
  ],
  providers: [
    NotificationService,
    AuthService,
    UserService,
    UserEditResolver,
    PositionRouteResolver,
    PassTokenResolver,
    NgxImageCompressService,
    DatePipe,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    NavbarServiceService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmationDialogComponent,
    ErrorMessageDialogComponent,
    ForgotPassDialogComponent,
    ChangeDialogComponent,
    TextInputConfirmationDialogComponent
  ]
})


export class AppModule { }
